import React from 'react'
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined'
import DashboardStatCard from './DashboardStatCard'
import { useDashboardStatsCard } from '../../store/dashboardStats'
import type { DashboardStatCardStationProps } from './types'

const NewPrepItemsLast24HoursCard: React.FC<DashboardStatCardStationProps> = ({ stationId }) => {
  const { value, loading, error } = useDashboardStatsCard(
    stationId,
    'newPrepItemsLast24Hours',
  )

  return (
    <DashboardStatCard
      title="New prep items"
      titleTooltip="New prep items added in the last 24 hours"
      value={value}
      loading={loading}
      error={error}
      icon={PostAddOutlinedIcon}
    />
  )
}

export default NewPrepItemsLast24HoursCard
